import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Accordion as BSAccordion } from "react-bootstrap";
import styled from "styled-components";

import AccordionToggle from "./AccordionToggle";

const StyledAccordion = styled(BSAccordion)`
  .accordion-item {
    border-bottom: 2px solid black;
  }
`;

function Accordion(props) {
  const { node } = props;

  if (isEmpty(node.children)) {
    return null;
  }

  return (
    <StyledAccordion flush>
      {node.children.map((accordionPair, index) => {
        const [header, body] = accordionPair.children[0].value.split("\n");

        if (!header || !body) return null;

        return (
          <BSAccordion.Item key={header} eventKey={index}>
            <AccordionToggle eventKey={index}>{header}</AccordionToggle>
            <BSAccordion.Collapse eventKey={index}>
              <p>{body}</p>
            </BSAccordion.Collapse>
          </BSAccordion.Item>
        );
      })}
    </StyledAccordion>
  );
}
export default observer(Accordion);

Accordion.propTypes = {
  node: PropTypes.shape({
    children: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

Accordion.defaultProps = {
  node: [],
};
